export const OBJECT = "object";
export const ACCIONES = "acciones";

export const STRING_SIDEBAR_EXPANDED = "SIDEBAR_EXPANDED";
export const STRING_TRUE = "true";
export const STRING_FALSE = "false";

export const ACCESS_TOKEN = "accessTokenGestionRefugio";

export const STRING_NAME_REFUGIO = "nombreRefugio";
export const STRING_COLOR_REFUGIO = "colorRefugio";
export const STRING_COLOR_PRIMARIO = "primayColor";
export const STRING_COLOR_SECUNDARIO = "secondaryColor";
export const STRING_URL_LOGO = "urlImage";